/**
 *  PHKL Custom -s
 *
 * This config only for PHKL GA
 */
import { FirebaseApp, initializeApp } from "firebase/app";
import { get } from "lodash";

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

const PHKLGAFirebaseConfig = {
  apiKey: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_API_KEY", ""),
  authDomain: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_AUTH_DOMAIN", ""),
  projectId: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_PROJECT_ID", ""),
  storageBucket: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_STORAGE_BUCKET", ""),
  messagingSenderId: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_MESSAGING_SENDER_ID", ""),
  appId: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_APP_ID", ""),
  measurementId: get(window, "envConfig.REACT_APP_PUBLIC_GA_FIREBASE_MEASUREMENT_ID", ""),
};

let app: FirebaseApp;

const isFirebaseConfigComplete = (config: FirebaseConfig): boolean => {
  const requiredFields: (keyof FirebaseConfig)[] = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
    "measurementId",
  ];

  return requiredFields.every((field) => config[field] && config[field].trim() !== "");
};

const isBrowserSupported = (): boolean => {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
};

const initializePHKLGaFireBaseSetUp = () => {
  if (!isFirebaseConfigComplete(PHKLGAFirebaseConfig)) {
    console.error(`PHKL GA firebase config was missing`);
    return null;
  }
  if (!isBrowserSupported()) {
    return null;
  }
  try {
    app = initializeApp(PHKLGAFirebaseConfig, "PHKLGA");
  } catch (error: any) {
    const errorMessage = error?.message || error?.toString() || String(error);
    console.error(`PHKL GA Firebase initialization failed: ${errorMessage}`);
    return null;
  }
};

const getPHKLGAFirebaseApp = (): FirebaseApp | undefined => {
  try {
    if (!app) {
      console.error("PHKL GA Firebase App is not initialized");
    }
    return app;
  } catch (error: any) {
    const errorMessage = error?.message || error?.toString() || String(error);
    console.error(`Get PHKL GA Firebase App failed: ${errorMessage}`);
    return undefined;
  }
};

export { initializePHKLGaFireBaseSetUp, getPHKLGAFirebaseApp };

// PHKL Custom -e
